import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SystemMetadataService } from '@twaice-fe/frontend/shared/services';
import { actions } from '@twaice-fe/frontend/shared/store';
import { BessMetadata, SystemDetails } from '@twaice-fe/shared/models';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { BehaviorSubject } from 'rxjs';
import { ChatDrawerService } from '../../chat/chat-drawer.service';
import { SystemLiveKpisComponent } from './system-live-kpis/system-live-kpis.component';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
const { systemActions } = actions;

@Component({
  selector: 'twaice-fe-system-overview-popover',
  templateUrl: './system-overview-popover.component.html',
  standalone: true,
  imports: [CommonModule, SystemLiveKpisComponent, NzDividerModule, SvgIconModule, NzBadgeModule, NzPopoverModule],
})
export class SystemOverviewPopoverComponent {
  @Input() system$: BehaviorSubject<SystemDetails | null>;
  @Input() visible = false;

  constructor(
    private store: Store,
    private systemMetadataService: SystemMetadataService,
    private router: Router,
    private chatDrawerService: ChatDrawerService
  ) {}

  getStorageLocation(bessMetadata: BessMetadata | null | undefined): string {
    return this.systemMetadataService.getStorageLocation(bessMetadata);
  }

  navigate(systemId: string, link: string) {
    this.store.dispatch(systemActions.selectSystem({ systemId: systemId }));
    this.router.navigateByUrl(link);
  }

  openChat(customerBk: string, systemBk: string, systemName: string) {
    this.chatDrawerService.openChatDrawer({ customerBk, systemBk, systemName });
  }
}
